import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, mediaUrl } from "@/lib/api";
import { Trophy, Gem, Layers, Crown } from "lucide-react";

export default function Leaderboard() {
  const [rows, setRows] = useState([]);
  const [sort, setSort] = useState("total");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/leaderboard").then(({ data }) => setRows(data)).finally(() => setLoading(false));
  }, []);

  const sorted = [...rows].sort((a, b) => b[sort] - a[sort]);
  const medal = ["#F5C542", "#C0C0C0", "#CD7F32"];

  return (
    <div className="max-w-4xl mx-auto px-4 lg:px-8 py-10">
      <div className="flex items-center gap-2 mb-1"><Trophy className="w-6 h-6 brand-text" /><p className="font-tech text-xs uppercase tracking-widest brand-text">Hall of fame</p></div>
      <h1 className="font-display text-4xl font-bold mb-4">Collector Leaderboard</h1>

      <div className="flex flex-wrap gap-2 mb-6">
        {[["total", "Most pieces", Layers], ["unique", "Most unique", Gem], ["rare", "Most rare", Crown], ["value", "Highest value", Trophy]].map(([k, label, Icon]) => (
          <button key={k} data-testid={`sort-${k}`} onClick={() => setSort(k)} className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap ${sort === k ? "text-white" : "surface border"}`} style={sort === k ? { background: "var(--brand)" } : {}}>
            <Icon className="w-4 h-4" /> {label}
          </button>
        ))}
      </div>

      {loading ? (
        <p className="text-muted-page animate-pulse font-tech">Loading…</p>
      ) : sorted.length === 0 ? (
        <div className="surface border rounded-2xl p-10 text-center">
          <p className="font-display text-2xl">No collections yet.</p>
          <p className="text-muted-page mt-1">Be the first to build a collection and top the board.</p>
          <Link to="/catalog" className="inline-block mt-4 px-5 py-2.5 rounded-full font-semibold text-white" style={{ background: "var(--brand)" }}>Start collecting</Link>
        </div>
      ) : (
        <div className="surface border rounded-2xl overflow-hidden" data-testid="leaderboard-list">
          {sorted.map((r, i) => (
            <Link key={r.user_id} to={`/u/${r.user_id}`} className="flex items-center gap-4 px-5 py-4 border-b hover:bg-black/[0.02]" style={{ borderColor: "var(--page-border)" }} data-testid={`leaderboard-row-${r.user_id}`}>
              <span className="w-8 text-center font-display text-2xl font-bold" style={{ color: medal[i] || "var(--page-muted)" }}>{i + 1}</span>
              <span className="w-11 h-11 rounded-full overflow-hidden grid place-items-center text-sm font-bold shrink-0" style={{ background: "var(--honey-500)", color: "#3a2a10" }}>
                {r.avatar_url ? <img src={mediaUrl(r.avatar_url)} alt="" className="w-full h-full object-cover" /> : (r.username || "?")[0].toUpperCase()}
              </span>
              <div className="flex-1 min-w-0">
                <p className="font-display text-lg font-bold truncate">{r.username}</p>
                {r.location && <p className="text-xs text-muted-page truncate">{r.location}</p>}
              </div>
              <div className="hidden sm:flex gap-5 text-sm font-tech text-muted-page">
                <span title="Total pieces">{r.total} pcs</span>
                <span title="Unique">{r.unique} uniq</span>
                <span title="Rare" className="brand-text">{r.rare} rare</span>
              </div>
              <span className="font-tech font-bold brand-text w-24 text-right">${r.value.toLocaleString()}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
